import React from 'react';
import FormInputTagsItem from './FormInputTagsItem';
import ListSearch from '../../list/ListSearch';

export default (props) => {
  const inputProps = {
    filterBy: 'itemId',
  };

  return <FormInputTagsItem {...props} inputComponent={ListSearch} inputProps={inputProps} />;
};
